import { useState } from "react";
import IndiaMap from "../components/IndiaMap";

export default function MapPage() {
    const [selected, setSelected] = useState("");

    return (
        <main className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20 min-h-screen">
            <p className="font-mono-tag text-xs uppercase text-brand-saffron mb-3">/ regions of india</p>
            <h1 data-testid="map-title" className="font-display font-extrabold text-4xl md:text-6xl tracking-tighter uppercase mb-4">
                Fashion is <span className="text-brand-saffron">local.</span>
            </h1>
            <p className="text-white/70 text-base md:text-lg max-w-2xl mb-10">
                Every district. Every weave. Discover India's traditional fashion by where the craft was born — from Banarasi silks to Kutch mirror-work.
            </p>

            <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-start">
                <div className="lg:col-span-3">
                    <IndiaMap selected={selected} onSelect={setSelected} />
                </div>
                <aside className="lg:col-span-2 grain-card p-6 md:p-8 rounded-md">
                    <p className="font-mono-tag text-xs uppercase text-brand-marigold mb-3">/ from the world for india</p>
                    <h3 className="font-display font-extrabold text-2xl md:text-3xl tracking-tight leading-tight mb-4">
                        Not every brand can list here.
                    </h3>
                    <p className="text-white/70 text-sm leading-relaxed mb-4">
                        We sort the styles and brands for you. Every listing is reviewed by a small editorial team so what you see is <span className="text-brand-saffron">actually</span> worth clicking into.
                    </p>
                    <p className="text-white/60 text-sm leading-relaxed">
                        Tap a marker on the map to explore heritage weaves and the founders bringing them into 2026.
                    </p>
                </aside>
            </div>
        </main>
    );
}
